(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["case-closet-bundle"] && !Shopify.designMode) return;
  try {
    
  (() => {
    document.querySelectorAll('.case-bundle').forEach(root => {
      if (root.dataset.carouselReady === 'true') return;
      root.dataset.carouselReady = 'true';
      const sizeSelect = root.querySelector('.case-bundle__size');
      const cards = [...root.querySelectorAll('.case-bundle__card')];
      const slots = [...root.querySelectorAll('.case-bundle__slot')];
      const stages = [...root.querySelectorAll('.case-bundle__stage')];
      const status = root.querySelector('.case-bundle__status');
      const submit = root.querySelector('.case-bundle__submit');
      const back = root.querySelector('.case-bundle__back');
      const totals = root.querySelector('.case-bundle__totals');
      const count = root.querySelector('.case-bundle__count');
      const error = root.querySelector('.case-bundle__error');
      const selectedNames = [...root.querySelectorAll('[data-selected-name]')];
      const stickySize = root.querySelector('[data-sticky-size]');
      const sizeScreen = root.querySelector('[data-flow-screen="size"]');
      const tray = root.querySelector('.case-bundle__tray');
      const strings = { chooseSize: status.textContent, showing: root.dataset.stringShowing, noCases: root.dataset.stringNoCases, selectTwo: root.dataset.stringSelectTwo, selectCase: root.dataset.stringSelectCase, pickFirst: root.dataset.stringPickFirst, pickSecond: root.dataset.stringPickSecond, selectContinue: root.dataset.stringSelectContinue, addBundle: root.dataset.stringAddBundle, adding: root.dataset.stringAdding, added: root.dataset.stringAdded, forSize: root.dataset.stringForSize, error: root.dataset.stringError, soldOut: root.dataset.stringSoldOut };
      const rate = Number(root.dataset.discountRate || .15);
      const marketCountry = root.dataset.country || window.Shopify?.country || '';
      let selected = [null, null];
      let previewed = [null, null];
      let activeStep = 'size';
      let scrollFrame;
      let sizeRequest = 0;
      const normalize = value => value.trim().replace(/\s+/g, ' ').toLowerCase();
      const variantsFor = card => JSON.parse(card.dataset.variants);
      const sizeMap = new Map();
      cards.filter(card => card.dataset.stage === '0').forEach(card => variantsFor(card).filter(v => v.available).forEach(v => {
        const key = normalize(v.title);
        if (key !== 'iphone 17 air' && !sizeMap.has(key)) sizeMap.set(key, v.title.trim().replace(/\bpro\b/gi, 'Pro').replace(/\bmax\b/gi, 'Max'));
      }));
      const order = ['iphone 18 pro max','iphone 18 pro','iphone 17 pro max','iphone 17 pro','iphone air','iphone 17','iphone 16 pro max','iphone 16 pro','iphone 16 plus','iphone 16','iphone 15 pro max','iphone 15 pro','iphone 15 plus','iphone 15'];
      [...sizeMap].sort((a,b) => {
        const ai = order.indexOf(a[0]), bi = order.indexOf(b[0]);
        if (ai > -1 && bi > -1) return ai - bi;
        if (ai > -1) return -1;
        if (bi > -1) return 1;
        return b[1].localeCompare(a[1], undefined, { numeric: true });
      }).forEach(([key,label]) => sizeSelect.add(new Option(label,key)));
      const money = cents => new Intl.NumberFormat(document.documentElement.lang || 'en-US', { style: 'currency', currency: root.dataset.currency }).format(cents / 100);
      async function variantIsAvailable(id) {
        try {
          const cartRoot = window.Shopify?.routes?.root || '/';
          const query = new URLSearchParams({ country: marketCountry, _: String(Date.now()) });
          const response = await fetch(`${cartRoot}variants/${id}.js?${query}`, { credentials: 'same-origin', cache: 'no-store', headers: { Accept: 'application/json' } });
          if (!response.ok) return false;
          const current = await response.json();
          return Boolean(current.available);
        } catch (fetchError) {
          return false;
        }
      }
      const imageForCard = card => card._variant?.image || card.dataset.productImage;
      const itemFromCard = card => ({ productId: card.dataset.productId, title: card.dataset.productTitle, image: imageForCard(card), variant: card._variant });
      const isFirstSelection = card => String(card.dataset.productId) === String(selected[0]?.productId || '');
      const firstCardFor = stage => cards.find(card => Number(card.dataset.stage) === stage && card._variant && card._available && (stage === 0 || !isFirstSelection(card)));
      function ensurePreview(stage) {
        const current = previewed[stage];
        const valid = current?._variant && current._available && Number(current.dataset.stage) === stage && (stage === 0 || !isFirstSelection(current));
        if (!valid) previewed[stage] = firstCardFor(stage) || null;
        return previewed[stage];
      }
      function lockPage() {
        document.documentElement.classList.add('case-bundle-flow-locked');
        document.body.classList.add('case-bundle-flow-locked');
      }
      // The tray is fixed to the bottom of the viewport on mobile, and its
      // height grows as more content appears inside it (sticky size line,
      // selected case names, the subtotal/total rows). The stage above it
      // used a fixed 150px bottom padding as a guess at the tray's height,
      // which meant a taller tray (more selections, longer names) would
      // physically overlap the carousel. Track the tray's real rendered
      // height instead and expose it as a CSS variable so the stage's
      // reserved space always matches.
      function syncTrayHeightVar() {
        if (!tray) return;
        const height = tray.getBoundingClientRect().height;
        root.style.setProperty('--case-bundle-tray-height', `${Math.ceil(height)}px`);
      }
      if (tray) {
        if ('ResizeObserver' in window) {
          new ResizeObserver(syncTrayHeightVar).observe(tray);
        } else {
          syncTrayHeightVar();
          window.addEventListener('resize', syncTrayHeightVar);
        }
      }
      function desktopFlowIsLocked() {
        return window.matchMedia('(min-width: 990px)').matches && document.body.classList.contains('case-bundle-flow-locked');
      }
      function mobileFlowIsLocked() {
        return window.matchMedia('(max-width: 989px)').matches && document.body.classList.contains('case-bundle-flow-locked');
      }
      function blockDesktopPageWheel(event) {
        if (!desktopFlowIsLocked()) return;
        const scroller = event.target.closest('.case-bundle__carousel');
        if (!scroller) {
          event.preventDefault();
          return;
        }
        const movingUp = event.deltaY < 0;
        const atTop = scroller.scrollTop <= 0;
        const atBottom = Math.ceil(scroller.scrollTop + scroller.clientHeight) >= scroller.scrollHeight;
        if ((movingUp && atTop) || (!movingUp && atBottom)) event.preventDefault();
      }
      function blockDesktopPageKeys(event) {
        if (!desktopFlowIsLocked()) return;
        if (event.target.closest('input, select, textarea, button, [contenteditable="true"]')) return;
        if (['ArrowUp', 'ArrowDown', 'PageUp', 'PageDown', 'Home', 'End', ' '].includes(event.key)) event.preventDefault();
      }
      function blockMobilePageTouch(event) {
        if (!mobileFlowIsLocked() || !event.touches.length) return;
        if (event.target.closest('.case-bundle__featured-media, .case-bundle__carousel')) return;
        event.preventDefault();
      }
      function blockMobilePageWheel(event) {
        if (mobileFlowIsLocked()) event.preventDefault();
      }
      function goTo(screen, pageTop = false) {
        lockPage();
        if (scrollFrame) window.cancelAnimationFrame(scrollFrame);
        const start = window.scrollY;
        const bounds = screen.getBoundingClientRect();
        const isDesktop = window.matchMedia('(min-width: 990px)').matches;
        const headerHeight = document.querySelector('body > .header-group')?.getBoundingClientRect().height || 0;
        const screenOffset = isDesktop ? headerHeight + 24 : (window.innerHeight - bounds.height) / 2;
        const target = pageTop ? 0 : Math.max(0, start + bounds.top - screenOffset);
        const duration = window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 0 : 480;
        const startedAt = performance.now();
        const move = now => {
          const progress = duration ? Math.min((now - startedAt) / duration, 1) : 1;
          const eased = 1 - Math.pow(1 - progress, 3);
          window.scrollTo(0, start + ((target - start) * eased));
          if (progress < 1) scrollFrame = window.requestAnimationFrame(move);
        };
        scrollFrame = window.requestAnimationFrame(move);
      }

      function renderFeatured() {
        stages.forEach((stageElement, stage) => {
          const card = ensurePreview(stage);
          const mediaElement = stageElement.querySelector('[data-featured-media]');
          const titleElement = stageElement.querySelector('[data-featured-title]');
          const priceElement = stageElement.querySelector('[data-featured-price]');
          if (!card) {
            mediaElement.replaceChildren();
            delete mediaElement.dataset.previewKey;
            titleElement.textContent = '';
            priceElement.textContent = '';
            return;
          }
          const previewKey = `${card.dataset.productId}:${card._variant.id}`;
          if (mediaElement.dataset.previewKey !== previewKey) {
            let media = [];
            try { media = JSON.parse(card.dataset.media || '[]'); } catch (parseError) { media = []; }
            const variantImage = imageForCard(card);
            if (variantImage) media = [{ src: variantImage, alt: card.dataset.productTitle }, ...media.filter(item => item.src !== variantImage)];
            if (!media.length && card.dataset.productImage) media = [{ src: card.dataset.productImage, alt: card.dataset.productTitle }];
            const fragment = document.createDocumentFragment();
            media.forEach((item, index) => {
              const image = document.createElement('img');
              image.src = item.src;
              image.alt = item.alt || card.dataset.productTitle;
              image.loading = index === 0 ? 'eager' : 'lazy';
              fragment.appendChild(image);
            });
            mediaElement.replaceChildren(fragment);
            mediaElement.dataset.previewKey = previewKey;
            mediaElement.scrollLeft = 0;
          }
          titleElement.textContent = card.dataset.productTitle;
          priceElement.textContent = money(card._variant.price);
        });
      }

      function render() {
        lockPage();
        const chosen = selected.filter(Boolean).length;
        slots.forEach((slot,index) => {
          const item = selected[index], image = slot.querySelector('.case-bundle__slot-image');
          slot.querySelector('.case-bundle__slot-name').textContent = item?.title || '';
          slot.querySelector('.case-bundle__slot-empty').hidden = Boolean(item);
          slot.querySelector('.case-bundle__remove').hidden = !item;
          image.hidden = !item?.image;
          if (item?.image) { image.src = item.image; image.alt = item.title; }
        });
        selectedNames.forEach((name,index) => {
          name.textContent = selected[index]?.title || '';
          name.hidden = !selected[index];
        });
        cards.forEach(card => {
          const stage = Number(card.dataset.stage), active = selected[stage]?.productId === card.dataset.productId;
          const excludedFromSecondStep = stage === 1 && isFirstSelection(card);
          const pending = Boolean(card._variant && card._availabilityPending);
          const available = Boolean(card._variant && card._available && !pending);
          const soldOut = Boolean(card._variant) && !pending && !available;
          card.hidden = !card._variant || excludedFromSecondStep;
          card.classList.toggle('is-sold-out', soldOut);
          card.setAttribute('aria-busy', String(pending));
          card.setAttribute('aria-disabled', String(pending || !available || excludedFromSecondStep));
          card.querySelector('.case-bundle__pick').disabled = pending || !available || excludedFromSecondStep;
          const soldOutBadge = card.querySelector('.case-bundle__sold-out-badge');
          if (soldOutBadge) soldOutBadge.hidden = !soldOut;
          card.querySelector('.case-bundle__pick').setAttribute('aria-pressed', String(active && !excludedFromSecondStep));
          card.querySelector('.case-bundle__number').textContent = active ? stage + 1 : '';
        });
        renderFeatured();
        const unlocked = Boolean(selected[0]) && activeStep === 1;
        stages[1].classList.toggle('is-locked', !unlocked);
        stages[1].setAttribute('aria-disabled', String(!unlocked));
        const lock = stages[1].querySelector('.case-bundle__lock');
        if (lock) lock.hidden = unlocked;
        count.textContent = `${chosen}/2`;
        back.hidden = activeStep === 'size';
        const sizeLabel = sizeSelect.selectedOptions[0]?.textContent || '';
        root.classList.toggle('has-size', Boolean(sizeSelect.value));
        root.querySelector('.case-bundle__tray-size').textContent = sizeLabel;
        stickySize.textContent = sizeLabel ? strings.forSize.replace('[size]', sizeLabel) : '';
        stickySize.hidden = !sizeLabel;
        if (activeStep === 'size') {
          submit.disabled = true;
          submit.textContent = strings.pickFirst;
        } else if (activeStep === 0) {
          submit.disabled = !selected[0];
          submit.textContent = selected[0] ? strings.selectContinue : strings.pickFirst;
        } else {
          submit.disabled = chosen !== 2;
          submit.textContent = chosen === 2 ? strings.addBundle : strings.pickSecond;
        }
        totals.hidden = chosen !== 2;
        if (chosen === 2) {
          const subtotal = selected.reduce((sum,item) => sum + item.variant.price, 0);
          root.querySelector('.case-bundle__subtotal').textContent = money(subtotal);
          root.querySelector('.case-bundle__total').textContent = money(Math.round(subtotal * (1 - rate)));
        }
        // Measure the tray now that all its content changes above have
        // been applied, so the reserved space above it updates in this
        // same paint instead of waiting for the async ResizeObserver
        // callback (which was lagging a frame and causing the featured
        // image/title to visibly jump between renders).
        syncTrayHeightVar();
      }
      function applySize() {
        const request = ++sizeRequest;
        selected = [null,null];
        previewed = [null,null];
        const chosenSize = sizeSelect.value;
        const candidates = new Map();
        cards.forEach(card => {
          card._variant = null;
          card._available = false;
          card._availabilityPending = false;
          card.hidden = true;
          card.querySelector('.case-bundle__pick').disabled = true;
          const variant = variantsFor(card).find(v => normalize(v.title) === chosenSize);
          card._variant = variant || null;
          if (variant?.available) candidates.set(String(variant.id), variant);
        });
        let visible = 0;
        cards.forEach(card => {
          const variant = variantsFor(card).find(v => normalize(v.title) === chosenSize);
          card._variant = variant || null;
          card._available = Boolean(variant?.available);
          card._availabilityPending = Boolean(variant?.available && chosenSize);
          card.querySelector('.case-bundle__pick').disabled = !card._available || card._availabilityPending;
          if (card._variant) {
            const productImage = card.querySelector('.case-bundle__product-image');
            if (productImage && imageForCard(card)) productImage.src = imageForCard(card);
            const image = card.querySelector('.case-bundle__forced-image');
            if (image) { if (!image.src) image.src = image.dataset.src; image.hidden = false; }
            const price = card.querySelector('.card-product--price');
            if (price) price.textContent = money(card._variant.price);
            if (card._available && card.dataset.stage === '0') visible += 1;
          }
        });
        const label = sizeSelect.selectedOptions[0]?.textContent || '';
        status.textContent = !sizeSelect.value ? strings.chooseSize : visible ? strings.showing.replace('[count]',visible).replace('[size]',label) : strings.noCases;
        previewed[0] = firstCardFor(0) || null;
        previewed[1] = firstCardFor(1) || null;
        render();
        if (chosenSize && candidates.size) {
          Promise.all([...candidates.keys()].map(async id => [id, await variantIsAvailable(id)])).then(availability => {
            if (request !== sizeRequest) return;
            const marketAvailability = new Map(availability);
            cards.forEach(card => {
              if (!card._variant || normalize(card._variant.title) !== chosenSize) return;
              card._available = Boolean(card._variant.available && marketAvailability.get(String(card._variant.id)));
              card._availabilityPending = false;
            });
            selected = selected.map(item => item && marketAvailability.get(String(item.variant.id)) ? item : null);
            if (!selected[0]) selected[1] = null;
            previewed = [ensurePreview(0), ensurePreview(1)];
            render();
          });
        }
        return true;
      }
      cards.forEach(card => card.querySelector('.case-bundle__pick').addEventListener('click', async () => {
        error.hidden = true;
        const stage = Number(card.dataset.stage);
        if (stage === 1 && !selected[0]) return;
        const candidate = card._variant;
        if (!candidate || !card._available || card._availabilityPending) return;
        card.querySelector('.case-bundle__pick').disabled = true;
        const available = await variantIsAvailable(candidate.id);
        if (!available) {
          cards.filter(item => item._variant?.id === candidate.id).forEach(item => { item._available = false; });
          if (selected[0]?.variant.id === candidate.id) selected[0] = null;
          if (selected[1]?.variant.id === candidate.id) selected[1] = null;
          previewed = [null, null];
          render();
          return;
        }
        cards.filter(item => item._variant?.id === candidate.id).forEach(item => { item._available = true; });
        card.querySelector('.case-bundle__pick').disabled = false;
        previewed[stage] = card;
        selected[stage] = itemFromCard(card);
        if (stage === 0) {
          selected[1] = null;
          previewed[1] = null;
          previewed[1] = firstCardFor(1) || null;
        }
        render();
      }));
      slots.forEach((slot,index) => {
        slot.addEventListener('click', event => {
          if (!selected[index] || event.target.closest('.case-bundle__remove')) return;
          activeStep = index;
          render();
          goTo(stages[index]);
        });
        slot.querySelector('.case-bundle__remove').addEventListener('click', event => {
          event.stopPropagation();
          selected[index] = null;
          if (index === 0) selected[1] = null;
          activeStep = index;
          render();
          goTo(stages[index]);
        });
      });
      root.querySelector('.case-bundle__tray-size').addEventListener('click', () => { activeStep = 'size'; render(); goTo(sizeScreen, true); });
      back.addEventListener('click', () => {
        activeStep = activeStep === 1 ? 0 : 'size';
        render();
        goTo(activeStep === 'size' ? sizeScreen : stages[0], activeStep === 'size');
      });
      root.querySelectorAll('[data-carousel-prev],[data-carousel-next]').forEach(button => button.addEventListener('click', () => {
        const carousel = button.closest('.case-bundle__stage').querySelector('.case-bundle__carousel');
        carousel.scrollBy({ left: carousel.clientWidth * (button.hasAttribute('data-carousel-prev') ? -.85 : .85), behavior: 'smooth' });
      }));
      root.querySelectorAll('.case-bundle__carousel').forEach(carousel => {
        let pointerId = null;
        let startX = 0;
        let startScrollLeft = 0;
        let dragged = false;
        carousel.addEventListener('pointerdown', event => {
          if (!window.matchMedia('(max-width: 989px)').matches) return;
          if (event.pointerType === 'mouse' && event.button !== 0) return;
          pointerId = event.pointerId;
          startX = event.clientX;
          startScrollLeft = carousel.scrollLeft;
          dragged = false;
          carousel.classList.add('is-dragging');
          carousel.setPointerCapture?.(pointerId);
        });
        carousel.addEventListener('pointermove', event => {
          if (event.pointerId !== pointerId) return;
          const distance = event.clientX - startX;
          if (Math.abs(distance) > 3) dragged = true;
          if (!dragged) return;
          carousel.scrollLeft = startScrollLeft - distance;
          if (event.cancelable) event.preventDefault();
        });
        const finishDrag = event => {
          if (event.pointerId !== pointerId) return;
          if (carousel.hasPointerCapture?.(pointerId)) carousel.releasePointerCapture(pointerId);
          pointerId = null;
          carousel.classList.remove('is-dragging');
        };
        carousel.addEventListener('pointerup', finishDrag);
        carousel.addEventListener('pointercancel', finishDrag);
        carousel.addEventListener('click', event => {
          if (!dragged) return;
          event.preventDefault();
          event.stopPropagation();
          dragged = false;
        }, true);
      });
      window.addEventListener('wheel', blockDesktopPageWheel, { passive: false });
      window.addEventListener('wheel', blockMobilePageWheel, { passive: false });
      window.addEventListener('keydown', blockDesktopPageKeys, { passive: false });
      window.addEventListener('touchmove', blockMobilePageTouch, { passive: false });
      const flowCartDrawer = document.querySelector('cart-drawer');
      if (flowCartDrawer) {
        let drawerWasOpen = flowCartDrawer.classList.contains('active');
        new MutationObserver(() => {
          const drawerIsOpen = flowCartDrawer.classList.contains('active');
          if (drawerWasOpen && !drawerIsOpen) window.setTimeout(lockPage, 0);
          drawerWasOpen = drawerIsOpen;
        }).observe(flowCartDrawer, { attributes: true, attributeFilter: ['class'] });
      }
      window.addEventListener('wiseCartClose', () => window.setTimeout(lockPage, 550));
      function soldOutError(stage) {
        const unavailable = selected[stage];
        cards.filter(card => card._variant?.id === unavailable?.variant.id).forEach(card => {
          card._available = false;
          card.querySelector('.case-bundle__pick').disabled = true;
        });
        selected[stage] = null;
        if (stage === 0) selected[1] = null;
        previewed[stage] = null;
        activeStep = stage;
        render();
        goTo(stages[stage]);
        return new Error(strings.soldOut.replace('[product]', unavailable?.title || 'This case'));
      }
      sizeSelect.addEventListener('change', () => {
        error.hidden = true;
        activeStep = 0;
        const applied = applySize();
        if (applied && sizeSelect.value) goTo(stages[0]);
      });
      submit.addEventListener('click', async () => {
        if (activeStep === 0 && selected[0]) {
          activeStep = 1;
          previewed[1] = ensurePreview(1);
          render();
          goTo(stages[1]);
          return;
        }
        if (selected.filter(Boolean).length !== 2) return;
        submit.disabled = true; submit.textContent = strings.adding; error.hidden = true;
        try {
          const cartRoot = window.Shopify?.routes?.root || '/';
          const availability = await Promise.all(selected.map(item => variantIsAvailable(item.variant.id)));
          const unavailableStage = availability.findIndex(available => !available);
          if (unavailableStage > -1) throw soldOutError(unavailableStage);
          const cartDrawer = document.querySelector('cart-drawer');
          const phoneSize = (sizeSelect.selectedOptions[0]?.textContent || '').trim();
          const pairId = window.crypto?.randomUUID?.() || `case-closet-${Date.now()}-${Math.random().toString(36).slice(2)}`;
          const requestBody = { items:selected.map(item => ({id:Number(item.variant.id),quantity:1,properties:{'_Case Closet Bundle':phoneSize,'_Case Closet Pair':pairId,'_Case Closet Size':phoneSize}})) };
          if (cartDrawer && typeof cartDrawer.getSectionsToRender === 'function') {
            requestBody.sections = cartDrawer.getSectionsToRender().map(section => section.id);
            requestBody.sections_url = window.location.pathname;
            if (typeof cartDrawer.setActiveElement === 'function') cartDrawer.setActiveElement(submit);
          }
          const response = await fetch(`${cartRoot}cart/add.js`, { method:'POST', credentials:'same-origin', headers:{'Content-Type':'application/json','X-Requested-With':'XMLHttpRequest',Accept:'application/json'}, body:JSON.stringify(requestBody) });
          if (!response.ok) {
            let payload = {};
            try { payload = await response.json(); } catch (parseError) { payload = {}; }
            const description = payload.description || payload.message || '';
            const unavailable = selected.find(item => description.includes(item.title));
            if (unavailable) {
              throw soldOutError(selected.indexOf(unavailable));
            }
            throw new Error(strings.error);
          }
          const payload = await response.json();
          const code = root.dataset.discountCode;
          if (code) window.localStorage.setItem('us_cart_discount', code);
          submit.disabled = true;
          submit.textContent = strings.added;
          document.documentElement.classList.remove('case-bundle-flow-locked');
          document.documentElement.classList.remove('case-bundle-footer-accessible');
          document.body.classList.remove('case-bundle-flow-locked');
          document.body.classList.remove('case-bundle-footer-accessible');
          if (cartDrawer && payload.sections && typeof cartDrawer.renderContents === 'function') {
            if (cartDrawer.classList.contains('is-empty')) cartDrawer.classList.remove('is-empty');
            cartDrawer.renderContents(payload);
            return;
          }
          window.location.assign(code ? `/discount/${encodeURIComponent(code)}?redirect=/cart` : '/cart');
        } catch (exception) { error.textContent = exception.message || strings.error; error.hidden = false; submit.disabled = false; render(); }
      });
      applySize();
      window.scrollTo(0, 0);
      lockPage();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["complementary-products"]) return;
  try {
    
  const handleIntersection = (entries, observer) => {
    if (!entries[0].isIntersecting) return;

    observer.unobserve(productRecommendationsSection);

    const url = productRecommendationsSection.dataset.url;

    fetch(url)
      .then(response => response.text())
      .then(text => {
        const html = document.createElement('div');
        html.innerHTML = text;
        const recommendations = html.querySelector('.product-recommendations');

        if (recommendations && recommendations.innerHTML.trim().length) {
          productRecommendationsSection.innerHTML = recommendations.innerHTML;
        }
      })
      .catch(e => {
        console.error(e);
      });
  };

  const productRecommendationsSection = document.querySelector('.product-recommendations');
  const observer = new IntersectionObserver(handleIntersection, {rootMargin: '0px 0px 200px 0px'});

  observer.observe(productRecommendationsSection);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["related-products"]) return;
  try {
    
      const productRecommendationsSection = document.querySelector('#productRecommendations');

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;

        observer.unobserve(productRecommendationsSection);

        const url = productRecommendationsSection.dataset.url;

        fetch(url)
          .then((response) => response.text())
          .then((text) => {
            const html = document.createElement('div');
            html.innerHTML = text;

            const recommendations = html.querySelector('#productRecommendations');

            if (recommendations && recommendations.innerHTML.trim().length) {
              productRecommendationsSection.innerHTML = recommendations.innerHTML;
            }
          })
          .catch((e) => {
            console.error(e);
          });
      };

      if (productRecommendationsSection) {
        const observer = new IntersectionObserver(handleIntersection, { rootMargin: '0px 0px 200px 0px' });
        observer.observe(productRecommendationsSection);
      }
    
  } catch(e) { console.error(e); }
})();
})();
